export enum SystemSettingKeysEnum {
    IsEnableLocationCheckbox = "ResourceFinder.EnableLocationCheckbox",
    // FavouriteListNoOfMostUsedResources = "FavouriteList.NoOfMostUsedResources",
    // ResourceFinderPageSize = "ResourceFinder.PageSize",
    // AttendeePageSize = "ResourceFinder.Attendee.PageSize",
    // AddinTrimLocation = "Addin.TrimLocation",
    DateFormat = "@DateFormat",
    DateSeperator = "@DateSeperator",
    TimeFormat = "@TimeFormat",
    ResourceFinderAssistantOrganizer = "ResourceFinder.AssistantOrganizer",
    ResourceFinderOrderFormVisible = "ResourceFinder.OrderForm.Visible",
    // EnableSOF = "EnableSOF",
    // ResourceFinderDetailVisible = "ResourceFinder.Detail.Visible",
    // ResourceFinderDisplayDetailCapacity = "ResourceFinder.DisplayDetailCapacity",
    // ResourceFinderDisplayDetailDeadLineInform = "ResourceFinder.DisplayDetailDeadLineInform",
    // ResourceFinderDisplayDetailDescription = "ResourceFinder.DisplayDetailDescription",
    // ResourceFinderDisplayDetailEmail = "ResourceFinder.DisplayDetailEmail",
    // ResourceFinderDisplayDetailFurtherDetail = "ResourceFinder.DisplayDetailFurtherDetail",
    // ResourceFinderDisplayDetailLightResource = "ResourceFinder.DisplayDetailLightResource",
    // ResourceFinderDisplayDetailLocation = "ResourceFinder.DisplayDetailLocation",
    // ResourceFinderDisplayDetailName = "ResourceFinder.DisplayDetailName",
    // WebAddinDisabledPlatforms = "@WebAddInDisabledPlatforms",
    // ResourceFinderTo = "ResourceFinder.To",
    // ResourceFinderFrom = "ResourceFinder.From",
    // ExchangeConflictRulesEnable = "ExchangeConflictRules.Enable",
    // ResourceFinderDisplayHightLightBufferTime = "ResourceFinder.DisplayHighLightBufferTime",
    OutlookAddinTimeLineVisible = "OutlookAddin.TimeLine.Visible",
    // ResourceFinderDisablePermission = "ResourceFinder.DisablePermission",
    PriorityReservationDaysReserved = "ResourceFinder.PriorityReservation.DaysReserved",
    ResourceFinderFloorPlan = "ResourceFinder.FloorPlan",
    // EnableCloseLocation = "RC.ClosedPeriod",
    // ResourceFinderRecurringAlternativeLimit ="ResourceFinder.Recurring.AlternativeLimit",
    // ResourceFinderRecurringEnableAlternative = "ResourceFinder.Recurring.EnableAlternative",
    DefaultFirstDayOfWeek = "RC.WeekStartDay",
    // EnableFindColleague = "ENABLE_FIND_COLLEAGUE",
    // ManifestGuid = "MANIFEST_GUID",
    // ResourceFinderFavouriteList = "ResourceFinder.FavouriteList",
    // MeetingInviteResourceInfoEnable = "MeetingInvite.ResourceInfo.Enable",
    OrderDeadlineStopMovingOrder = "Order.Deadline.StopMovingOrder",
    // MultiSelectResourceType = "ResourceFinder.MultiSelectResourceType"
}